import Main from './views/main.c';
export default Main;
